import React, {useRef, useState} from 'react';
import axios, {AxiosRequestConfig} from 'axios';
import {useAuth0} from "@auth0/auth0-react";
import {useImageUploader} from "../../util/ImageUploader";

type Props = {
  locationName?: string,
  imageUrl: string | null | undefined,
  error?: string | null | undefined,
  onChange: (url: string) => void,
}

export const PhotoUpload = (props: Props) => {

  const uploader = useImageUploader()
  const [error, setError] = useState<string>();
  const fileUploadRef = useRef<HTMLInputElement>(null);

  return <div className={'VerticalFlex Flex1'} style={{maxWidth: '100%'}}>

    <div className={'PhotoUploadCarousel'}>

      {props.locationName && <div className={'LabeledTextInputLabel'}>{props.locationName} photo(s)</div>}


      {/* show the image if there is one uploaded. */}
      {props.imageUrl && <div className={'PhotoUploadSinglePhoto'}>
        <div onClick={() => {
          props.onChange('')
        }} className={'PhotoUploadClose'}>
          <img className={'PhotoUploadCloseImage'} src={require('../../images/icons/close.png')} alt="Delete"/>
        </div>
        <img className={'PhotoUploadPhoto'} src={props.imageUrl} alt="Uploaded content"/>
      </div>
      }

      {!props.imageUrl && <button className={'PhotoUploadAdd'} onClick={() => fileUploadRef.current?.click()}>
        <img src={require('../../images/icons/add_photo.png')}/>
        <span>Upload a photo</span>
      </button>}

      <input ref={fileUploadRef} type="file" style={{display: 'none'}} onChange={(e) => {
        if (e.target.files && e.target.files.length > 0) {
          uploader.upload(e.target.files[0])
              .then(value => props.onChange(value))
              .catch(e => setError(e.toString()))
        }
      }}/>
    </div>

    {uploader.uploadProgress > 0 && <div>
      <progress value={uploader.uploadProgress} max="100"/>
      {uploader.uploadProgress}%</div>}
    {error && <div className={'LabeledInputError'}>{error}</div>}
    {props.error && <div className={'LabeledInputError'}>{props.error}</div>}
  </div>
};

